// ============================================================================
// CANCUN100 — Segmentado.js  (Bloque 25: una sola pieza para todos los toggles segmentados)
// ----------------------------------------------------------------------------
// MXN/USD · Sí/No · Por persona/Promoción · Becados/50-50 · Español/English/Português · Completo/Resumido ·
// Tarjeta promo/Ficha completa · Claro/Oscuro… Mismo alto (36), mismo radio (8), mismo color activo (equipo).
// Uso: <Segmentado valor={x} opciones={[[clave, 'Etiqueta'], …]} onChange={(clave) => …} />
// ============================================================================
import React from 'react';

export default function Segmentado({ valor, opciones, onChange, disabled = false, style, ancho }) {
  return (
    <div className="au-toggle" role="group" style={{ ...(ancho === 'full' ? { display: 'flex', width: '100%' } : {}), ...style }}>
      {opciones.map(([clave, etiqueta]) => (
        <button key={String(clave)} type="button" aria-pressed={valor === clave} disabled={disabled}
          onClick={() => { if (!disabled && valor !== clave) onChange(clave); }}
          style={ancho === 'full' ? { flex: 1 } : undefined}>
          {etiqueta}
        </button>
      ))}
    </div>
  );
}
